import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap"
import VueCurrencyInput from 'vue-currency-input'

Vue.use(VueCurrencyInput, {
  globalOptions: { currency: null, allowNegative: false }
})

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.filter('currency', function (value) {
  if (!value) return ''
  return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
})

Vue.filter('number', function (value) {
  if (!value) return ''
  return parseFloat(value).toString().replace(/\d(?=(\d{3})+$)/g, '$&,')
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

import "@fortawesome/fontawesome-free/css/all.css"